export const meta = { id: 'O15', slug: 'criar-aulas', title: 'Como criar Aulas', description: 'Crie Aulas dentro dos Módulos e organize os conteúdos e recursos disponíveis.', profile: 'owner', category: 'treinamentos', type: 'task', status: 'published', order: 450, keywords: ['aulas','criar aula','conteúdo','recursos','vídeo','texto'], previous: 'O14', next: 'O16', related: ['O14','A10'], updatedAt: '2026-08-17', appVersion: 'v1' }

# Como criar Aulas

Cada Aula pertence a um Módulo e representa uma unidade de aprendizagem que o Aluno poderá acessar e concluir.

<HelpImage pendingId="O14.1" alt="Tela de criação ou edição de Aula" />

## Conteúdos disponíveis

Conforme a configuração atual do Personagrama, a Aula pode utilizar texto, vídeo, links, arquivos e outros recursos já suportados pela plataforma.

<Steps>
  <Step title="Crie a Aula">Defina o título e sua posição no Módulo.</Step>
  <Step title="Adicione o conteúdo">Inclua os materiais necessários para atingir o objetivo da Aula.</Step>
  <Step title="Revise os recursos">Confirme links, arquivos e demais materiais.</Step>
  <Step title="Verifique a conclusão">Garanta que a ação de concluir a Aula esteja coerente para o Aluno.</Step>
</Steps>

<Callout type="tip">Revise a Aula também no celular quando o conteúdo ou os recursos puderem exigir mais espaço de tela.</Callout>
